import React from "react";
import { Button, Row } from "react-bootstrap";
//import Pdf from "../pdf/bar_assosiation_dehradun.pdf";
import memebership1 from "../pdf/membership.pdf";
import registration_form from "../pdf/bar_registraion_form.pdf";

const Membership = () => {
  return (
    <section className="p-5 mx-md-5">
      <h1>Membership</h1>
      <Row className="mt-4">
        <Button
          className="col-md-3 col-sm-4 mb-sm-2 mb-md-0 justify-content-center align-content-center"
          // href="https://www.barcouncilofuttarakhand.org/wp-content/uploads/2021/05/registration-form-2023-1.pdf"
          href={registration_form}
          target="_blank"
        >
          Bar Council of Uttarakhand
        </Button>
        {/* <Button
          className="col-md-3 col-sm-4 ms-md-3 mt-sm-2 mt-md-0 btn-warning justify-content-center align-content-center"
          href={Pdf}
          target="_blank"
        >
          Bar Association of Dehardun
        </Button> */}
        <Button
          className="col-md-3 col-sm-4 mb-sm-2 mb-md-0 ms-md-3 justify-content-center align-content-center btn-warning"
          href={memebership1}
          target="_blank"
        >
          Affidavit and Registration Form
        </Button>
        <Button
          className="col-md-3 col-sm-4 ms-md-3 mt-sm-2 mt-md-0 btn-success"
          href="https://app.barassociationdehradun.com/"
          //target="_blank"
        >
          Apply Online Bar Association of Dehardun
        </Button>
      </Row>
    </section>
  );
};

export default Membership;
